<template>
  <DeleteButton
    size="large"
    :disabled="disabled"
    @click="confirmDeleteRelease"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { DELETE_UNCOMMITTED_RELEASE } from '@/store/types';

import DeleteButton from '@@/common/action-buttons/DeleteButton';
import packageName from '@/mixins/packageName';

export default {
  name: 'NewReleaseDeleteButton',
  components: {
    DeleteButton,
  },
  mixins: [packageName],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({
      deleteUncommittedRelease: DELETE_UNCOMMITTED_RELEASE,
    }),
    confirmDeleteRelease() {
      return this.$confirm(
        this.$t('APP.RELEASES.ARE_YOU_SURE'),
        this.$t('WARNING'),
        {
          confirmButtonText: this.$t('REMOVE'),
          cancelButtonText: this.$t('CANCEL'),
          confirmButtonClass: 'new-release__delete-confirm-button',
          type: 'error',
        },
      )
        .then(() => {
          this.deleteRelease();
        })
        .catch(() => {});
    },
    deleteRelease() {
      this.$emit('update:loading', true);
      return this.deleteUncommittedRelease(this.packageName)
        .catch(({ message }) => this.$message.error(message))
        .finally(() => {
          this.$emit('update:loading', false);
        });
    },
  },
};
</script>
